<template>
  <div>
    <admin-side-nav></admin-side-nav>
    <router-view id="page-content-wrapper"></router-view>
  </div>
</template>

<script>

import AdminSideNav from "@/components/sub_components/admin/AdminSideNav";

export default {
name: "Admin",
  components: {
    AdminSideNav
  }
}
</script>

<style scoped>

</style>
